import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { TimesheetEntry } from '.'
import { UserRestrictedView } from '../'
import { connect } from "react-redux"

export class TimesheetEntryWrapper extends Component{

  static propTypes = {
    user: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
  }

  get loaded(){
    return this.props.user.id
  }

  render = () =>
      <div>
        { this.loaded && <UserRestrictedView component={TimesheetEntry} {...this.props}/>}
      </div>
}

export default connect(state => { return { ...state.session} })(TimesheetEntryWrapper)